module.exports = __webpack_public_path__ + "img/1.13b3ea56.png";